import { render, staticRenderFns } from "./QueueForm.vue?vue&type=template&id=90d6ffbc&scoped=true&"
import script from "./QueueForm.vue?vue&type=script&lang=js&"
export * from "./QueueForm.vue?vue&type=script&lang=js&"
import style0 from "./QueueForm.vue?vue&type=style&index=0&id=90d6ffbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d6ffbc",
  null
  
)

export default component.exports